import { z } from "zod";

/** A card the athlete can place on their dashboard, under the next session. */
export enum DashboardWidget {
  WORKOUT = "workout",
  DIET = "diet",
  STREAK = "streak",
  WEIGHT = "weight",
  RECOVERY = "recovery",
  MUSCLES = "muscles",
  TRANSFORMATION = "transformation",
  COACHES = "coaches",
  COMING_UP = "coming_up",
  EVENTS = "events",
  STUDIO = "studio",
}

/**
 * The athlete's own dashboard: the cards in the order they put them, each shown or hidden. A card
 * missing from the list (one added to the app later) keeps its default place and visibility.
 */
export const dashboardLayoutSchema = z
  .array(z.object({ id: z.enum(DashboardWidget), visible: z.boolean() }))
  .max(Object.values(DashboardWidget).length)
  .refine((items) => new Set(items.map((item) => item.id)).size === items.length, "each card once");
export type DashboardLayout = z.infer<typeof dashboardLayoutSchema>;
